import { Box, styled, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const PreviewDetailsContent = styled(Flex)`
  color: #36354C;
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  font-weight: 400;
  alignItems: center,
  line-height: 20px;
  margin-left: 12px;
  span {
    font-weight: 500;
  }
  .price-text {
    color: #d83d37;
  }
`;

export const PreviewDetailsDesc = styled(Text)`
  font-weight: 400;
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  color: #36354c;
  line-height: 18px;
  margin: -10px 0 16px 0;
  gap: 2px
`;

export const PreviewDetailsCoverage = styled(Text)`
  font-weight: 600;
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  padding-bottom: 4px;
`;

export const PreviewDetailsWrapper = styled(Box)`
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const PreviewDetailsMoreCovers = styled(Flex)`
  color: #040222;
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  font-weight: 500;
  text-decoration: underline;
  alignItems: center,
  line-height: 20px;
  gap: 5px
  span {
    font-weight: 500;
  }
  .price-text {
    color: #d83d37;
  }
`;

